import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { apiGet } from "./client";
import { useTicketSize } from "../ticket-size";
import type { ThreeWayBasis } from "../../../../components/PortfolioPerformance/basis-toggle";
import {
  cohortColor,
  type CohortYear,
  type MonthRow,
} from "./lifetime-loss-projections";

export { cohortColor };
export type { CohortYear };

export interface LifetimePrepaymentProjectionsSummary {
  cohorts: string[];
  /** cohort year -> month labels that are realized readings (the rest of its curve is projected) */
  realized: Record<string, string[]>;
  forecast: MonthRow[];
  projection: MonthRow[];
}

// null only when the selected industry has no rows in the chart table -- render an empty
// state, not a fabricated chart. The toggle picks the rows that are realized, projected, or of active cohorts.
export function useLifetimePrepaymentProjections(industry: string, basis: ThreeWayBasis) {
  const { ticket } = useTicketSize();
  return useQuery({
    queryKey: ["lifetime-prepayment-projections", industry, basis, ticket ?? "all"],
    queryFn: () =>
      apiGet<LifetimePrepaymentProjectionsSummary | null>("/lifetime-prepayment-projections", {
        industry,
        ticket,
        basis,
      }),
    placeholderData: keepPreviousData,
  });
}
